import React, { useEffect, useState } from 'react';
import { Box, Button, Card, Container, Grid, Stack, SwipeableDrawer, TextField, Typography } from '@mui/material';
import { dispatch, useSelector } from '../../../redux/store';
import { PATH_DASHBOARD } from '../../../routes/paths';
import useSettings from '../../../hooks/useSettings';
import Page from '../../../components/Page';
import Iconify from '../../../components/Iconify';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import DataGridTable from '../../../components/table/DataGridTable';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';
import { safeJSONParse } from '../../../utils/common';
import { addGuestCard, getGuestCard, updateGuestCard } from '../../../redux/slices/guestRedux/guestCardRedux';

export default function GuestCards() {
  // Code for excel
  // =CHAR(65+MOD(A1,26)) & CHAR(65+MOD(A1*3,26)) & CHAR(48+MOD(A1*5,10)) & CHAR(65+MOD(A1*7,26)) & CHAR(48+MOD(A1*11,10)) & CHAR(65+MOD(A1*13,26))
  const pageName = 'Guest Cards';
  const pageNameSingular = 'Guest Card';
  const { themeStretch } = useSettings();
  const dataModel = {
    id: '',
    code: '',
  };
  const [selectedDataObj, setSelectedDataObj] = useState(dataModel);
  const [isAdd, setIsAdd] = useState(false);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [variationList, setVariationList] = useState([]);
  const [rowSelection, setRowSelection] = useState(false);
  const { data, addData } = useSelector((state) => state?.guestCard);

  useEffect(() => {
    dispatch(getGuestCard());
  }, []);

  useEffect(() => {
    setVariationList(data?.map((value) => ({ ...value, seo: safeJSONParse(value?.seo) })));
    setIsModelOpen(false);
  }, [data]);

  const manageModel = (modelData, type) => {
    if (isModelOpen) {
      setIsModelOpen(false);
    } else {
      setIsModelOpen(true);
      setIsAdd(type === 'add');
      if (type === 'add') {
        setSelectedDataObj(dataModel);
      } else {
        setSelectedDataObj(modelData);
      }
    }
  };

  useEffect(() => {
    if (addData?.data) {
      dispatch(getGuestCard());
    }
  }, [addData]);

  const updateEditingData = (key, value) => {
    setSelectedDataObj({
      ...selectedDataObj,
      [key]: value,
    });
  };


  const handleSubmit = () => {
    if (selectedDataObj.code.length === 0) {
      toast.error('Code is required!');
    } else {
      dispatch(isAdd ? addGuestCard([selectedDataObj]) : updateGuestCard(selectedDataObj));
    }
  };

  return (
    <Page title={`${pageName}`}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={`${pageName}`}
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            {
              name: 'Guest',
              href: '',
            },
            { name: `${pageName}` },
          ]}
          action={
            <Button
              variant='contained'
              startIcon={<Iconify icon='eva:plus-fill' />}
              onClick={() => {
                manageModel(dataModel, 'add');
              }}
            >
              New {`${pageName}`}
            </Button>
          }
        />

        <DataGridTable
          name={`${pageName} List`}
          data={variationList}
          column={[{
            accessorKey: 'id',
            header: 'Id',
          },{
            accessorKey: 'code',
            header: 'Code',
          },{
            accessorKey: 'qr',
            header: 'Qr',
            Cell: ({ cell, row }) => {
              return <img width={150} height={150} src={`https://api.qrserver.com/v1/create-qr-code/?data=${row?.original?.code}`} />;
            },
          },
          ]}
          onRowClick={(row) => {
            manageModel(row?.original, 'edit');
          }}
          isRowClickable={true}
          isLoading={false}
          rowSelection={rowSelection}
          setRowSelection={setRowSelection}
          enableRowSelection={false}
          enableRowActions={false}
          renderRowActionItems={(value, closeMenu) => []}
        />

        <SwipeableDrawer
          anchor={'top'}
          open={isModelOpen}
          onOpen={() => setIsModelOpen(true)}
          onClose={() => setIsModelOpen(false)}
          PaperProps={{
            sx: {
              width: '90%',
              height: '90%',
              marginLeft: '5%',
              marginTop: '3%',
              borderRadius: '10px',
            },
          }}
        >
          <Box sx={{ p: 2 }}>
            <h1>
              {isAdd ? 'Add' : 'Edit'} {pageNameSingular}
            </h1>
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={12} md={8}>
              <Stack spacing={1} sx={{ p: 1 }}>
                <Card sx={{ p: 3 }}>
                  <Typography variant='subtitle1' padding='10px 0'>
                    {`${pageNameSingular}`} Information
                  </Typography>
                  <Stack spacing={3}>
                    <TextField fullWidth label='Code' value={selectedDataObj?.code} onChange={(e) => updateEditingData('code', e.target.value)} />
                  </Stack>
                </Card>

              </Stack>
            </Grid>

            <Grid item xs={12} md={4}>
              <Stack spacing={1} sx={{ p: 1 }}>
                <Card sx={{ p: 3 }}>
                  <Stack spacing={3} sx={{ p: 3 }}>
                    <LoadingButton type='submit' variant='contained' size='large' style={{ width: '100%' }} onClick={handleSubmit}>
                      {isAdd ? `Add ${pageNameSingular}` : `Save ${pageNameSingular}`}
                    </LoadingButton>
                    <Button
                      color='info'
                      variant='outlined'
                      size='large'
                      style={{ width: '100%' }}
                      onClick={() => {
                        manageModel(dataModel, 'add');
                      }}
                    >
                      Close
                    </Button>
                  </Stack>
                </Card>
              </Stack>
            </Grid>
          </Grid>
        </SwipeableDrawer>
      </Container>
    </Page>
  );
}
